import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { formatChannelAttributeName } from "./EditPageUtils"


export default function ChangesTable({...params}){

    let channelAttributeNames = params.channelAttributeNames
    let oldValues = params.oldValues
    let newValues = params.newValues

    let rows = getChangesTableRows(channelAttributeNames, oldValues, newValues)

    return (
        <TableContainer >
          
            <Table size="small" >

                <TableHead>
                <TableRow>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left">Old</TableCell>
                    <TableCell align="left">New</TableCell>
                </TableRow>
                </TableHead>

                <TableBody sx={{overflow: 'scroll' }}>
                    {rows.map((row) => (
                        <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}>

                            <TableCell align="left" component="th" scope="row">
                                <Typography variant="h6">{row[0]}</Typography>
                            </TableCell>

                            <TableCell align="left">
                                <Typography variant="h6">{String(row[1])}</Typography>
                            </TableCell>

                            <TableCell align="left">
                                <Typography variant="h6">{String(row[2])}</Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>

            </Table>
        </TableContainer>
    );
}

function getStationContactsChanges(oldValue, newValue){
    let stationContactsChanges = []

    for(let i = 0; i < Math.max(oldValue.length, newValue.length); i++){

        let oldContact = oldValue[i]
        let oldName = ''
        let oldEmail = ''
        if (oldContact !== undefined){
            oldName = oldContact.name
            oldEmail = oldContact.email
        }

        let newContact = newValue[i]
        let newName = ''
        let newEmail = ''
        if (newContact !== undefined){
            newName = newContact.name
            newEmail = newContact.email
        }

        let title = 'Contact' + (i+1) + ":"

        if (oldName !== newName && oldEmail !== newEmail)
            stationContactsChanges.push([title, "\n" + oldName + " " + oldEmail, newName + " " + newEmail])

        else if (oldName !== newName)
            stationContactsChanges.push([title, oldName, newName])

        else if (oldEmail !== newEmail)
            stationContactsChanges.push([title, oldEmail, newEmail])
            
        
    }
    return stationContactsChanges
}


function getChangesTableRows(channelAttributeNames, oldValues, newValues){

    let rows = []

    for (let i = 0; i < newValues.length; i++){

        let name = channelAttributeNames[i]
        let oldValue = oldValues[i]
        let newValue = newValues[i]

        if (String(newValue).toLowerCase() === 'true') newValue = 'True'
        if (String(newValue).toLowerCase() === 'false') newValue = 'False'

        if (oldValue !== newValue){
            name = formatChannelAttributeName(name)
            if (name === 'Station Contacts') {
                let contactsChanges = getStationContactsChanges(oldValue, newValue)
                rows = rows.concat(contactsChanges)
            }           
            else rows.push([ name + ":", oldValue, newValue ])
        }
    }
    return rows;
}
